/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctor } from 'app/shared/model/doctor.model';
import { IHospital } from 'app/shared/model/hospital.model';

export interface ITreatmentTemplate {
  id?: string;
  name?: string | null;
  description?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  global?: boolean;
  sharedInternally?: boolean;
  doctor?: IDoctor | null;
  hospital?: IHospital | null;
}

export const defaultValue: Readonly<ITreatmentTemplate> = {
  active: false,
  global: false,
  sharedInternally: false,
};
